import useConversationsContext from '@contexts/conversationsContext'
import { useSearchParams } from 'react-router-dom'
import useLoading from '@hooks/useLoading'
import axios from '@utils/webRequests'

import YesOrNo from '@elements/YesOrNo'
import { Toast } from '@base-ui/react'

const BlockUser = ({ isOpen, setClosed, handlePromise, otherUser }) => {
  const { isLoading, isLoadingDelayed, setIsLoading } = useLoading()
  const toastManager = Toast.useToastManager()

  // couples the internal open/closed state to the parent component state
  // useEffect(() => {
  //   if (isOpen && !isBlockDialogOpen) {
  //     if (authState?.user?.isAnonymous) {
  //       registerUser.open({ search: { blocked_access: true } })
  //       // NOTE: We have to set the parent state to close here so the internal open/closed state stays in sync
  //       onClose()
  //     } else {
  //       openBlockDialog()
  //     }
  //   } else if (!isOpen && isBlockDialogOpen) {
  //     closeBlockDialog()
  //   }
  // }, [isOpen])

  // When they block dialog gets closed unexpectedly (back navigation, for example)
  // this will update the parent state to reflect the internal closed state.
  // NOTE: it also triggers the above useEffect after, but since the two states 'should' be
  //       the same, nothing happens because the conditions aren't met.
  // useEffect(() => {
  //   if (!isBlockDialogOpen && isOpen) {
  //     onClose?.()
  //   }
  // }, [isBlockDialogOpen])

  const handleBlock = (yesOrNo) => {
    yesOrNo ? handleYes() : setClosed()
  }

  const handleYes = () => {
    setIsLoading(true)
    const promise = axios.post(`/api/my/users/${otherUser?.uuid || otherUser?.nearbyUuid}/blocks`)
      .then(() => {
        setClosed()
        handlePromise?.(Promise.resolve())
        toastManager.add({ text: 'blocked successfully' })
      })
      .catch((err) => {
        console.log(err)
        handlePromise?.(Promise.reject(err))
        toastManager.add({ text: 'failed to block user' })
      })
      .finally(() => setIsLoading(false))

  }

  return(
    <YesOrNo
      isLoading={isLoading}
      isLoadingDelayed={isLoadingDelayed}
      isOpen={isOpen}
      setClosed={setClosed}
      handleSelect={handleBlock}
      title='Block user?'
      body='Block this user? You should not be able to interact after blocking.'
    />
  )
}


const DeleteConversations = ({ isOpen, setClosed, handlePromise }) => {
  const { isLoading, isLoadingDelayed, setIsLoading } = useLoading()
  const { removeConversationFromAll } = useConversationsContext()
  const toastManager = Toast.useToastManager()
  const [searchParams] = useSearchParams()

  const handleDeleteConversation = (yesOrNo) => {
    yesOrNo ? handleYes() : setClosed()
  }

  const handleYes = () => {
    const conversationId = searchParams.get('conversation_id')
    if (!conversationId) {
      toastManager.add({ text: 'failed to get conversation to delete' })
      return;
    }

    setIsLoading(true)
    // Submit request and handle result in dialog, then pass promise to callback for handling in higher context
    axios.delete(`/api/my/conversations/${conversationId}`)
      .then(() => {
        removeConversationFromAll(conversationId)
        setClosed()
        handlePromise?.(Promise.resolve())
        toastManager.add({ text: 'deleted conversation' })
      })
      .catch((err) => {
        console.log(err)
        toastManager.add({ text: 'failed to delete conversation' })
        handlePromise?.(Promise.reject(err))
      })
      .finally(() => setIsLoading(false))
  }

  return (
    <YesOrNo
      isLoading={isLoading}
      isLoadingDelayed={isLoadingDelayed}
      isOpen={isOpen}
      setClosed={setClosed}
      handleSelect={(yesOrNo) => handleDeleteConversation(yesOrNo)}
      title='Delete conversation'
      body='Delete this conversation, and make it disappear for both users?'
    />
  )
}

const DeletePost = ({ isOpen, setClosed, handlePromise, postId }) => {
  const { isLoading, isLoadingDelayed, setIsLoading } = useLoading()
  const toastManager = Toast.useToastManager()
  const [searchParams] = useSearchParams()

  const handleDelete = (yesOrNo) => {
    yesOrNo ? handleYes() : setClosed()
  }

  const handleYes = () => {
    setIsLoading(true)
    // Submit request and handle result in dialog, then pass promise to callback for handling in higher context
    axios.delete(`/api/my/posts/${postId}`)
      .then(() => {
        setClosed()
        handlePromise?.(Promise.resolve())
        toastManager.add({ text: 'deleted post' })
      })
      .catch((err) => {
        console.log(err)
        handlePromise?.(Promise.reject(err))
        toastManager.add({ text: 'failed to delete post' })
      })
      .finally(() => setIsLoading(false))
  }

  return (
    <YesOrNo
      isLoading={isLoading}
      isLoadingDelayed={isLoadingDelayed}
      isOpen={isOpen}
      setClosed={setClosed}
      handleSelect={(yesOrNo) => handleDelete(yesOrNo)}
      title='Delete post?'
      body='This action cannot be undone'
    />
  )
}

export {
  BlockUser,

  DeleteConversations,
  DeletePost,
}